export class FunctionMappingNotFound extends Error {
    constructor(functionName: string) {
        super(
            `Function Config not found for ${functionName} in the functionMapping param`,
        );
        this.name = 'FunctionMappingNotFound';
    }
}
